export const filterStatus = [
    { value: true, label: "True" },
    { value: false, label: "False" }
  ];

  export const payment = [
    {value : 'Topup', label : 'Topup'},
    {value : 'Reduce', label : 'Reduce'}
  ]

 export const countries = [
    { value: "NG", label: "Nigeria" },
    { value: "AF", label: "Afghanistan" },
    { value: "AX", label: "Aland Islands" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Algeria" },
    { value: "AS", label: "American Samoa" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AI", label: "Anguilla" },
    { value: "AQ", label: "Antarctica" },
    { value: "AG", label: "Antigua and Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Armenia" },
    { value: "AW", label: "Aruba" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Austria" },
    { value: "AZ", label: "Azerbaijan" },
    { value: "BS", label: "Bahamas" },
    { value: "BH", label: "Bahrain" },
    { value: "BD", label: "Bangladesh" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Belarus" },
    { value: "BE", label: "Belgium" },
    { value: "BZ", label: "Belize" },
    { value: "BJ", label: "Benin" },
    { value: "BM", label: "Bermuda" },
    { value: "BT", label: "Bhutan" },
    { value: "BO", label: "Bolivia" },
    { value: "BA", label: "Bosnia and Herzegovina" },
    { value: "BW", label: "Botswana" },
    { value: "BV", label: "Bouvet Island" },
    { value: "BR", label: "Brazil" },
    { value: "IO", label: "British Indian Ocean Territory" },
    { value: "VG", label: "British Virgin Islands" },
    { value: "BN", label: "Brunei Darussalam" },
    { value: "BG", label: "Bulgaria" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "KH", label: "Cambodia" },
    { value: "CM", label: "Cameroon" },
    { value: "CA", label: "Canada" },
    { value: "CV", label: "Cape Verde" },
    { value: "KY", label: "Cayman Islands" },
    { value: "CF", label: "Central African Republic" },
    { value: "TD", label: "Chad" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "China" },
    { value: "CX", label: "Christmas Island" },
    { value: "CC", label: "Cocos (Keeling) Islands" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Comoros" },
    { value: "CG", label: "Congo" },
    { value: "CK", label: "Cook Islands" },
    { value: "CR", label: "Costa Rica" },
    { value: "HR", label: "Croatia" },
    { value: "CU", label: "Cuba" },
    { value: "CY", label: "Cyprus" },
    { value: "CZ", label: "Czech Republic" },
    { value: "CI", label: "Côte d'Ivoire" },
    { value: "KP", label: "Democratic People's Republic of Korea" },
    { value: "CD", label: "Democratic Republic of the Congo" },
    { value: "DK", label: "Denmark" },
    { value: "DJ", label: "Djibouti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "Dominican Republic" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "Egypt" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Equatorial Guinea" },
    { value: "ER", label: "Eritrea" },
    { value: "EE", label: "Estonia" },
    { value: "ET", label: "Ethiopia" },
    { value: "FO", label: "Faeroe Islands" },
    { value: "FK", label: "Falkland Islands (Malvinas)" },
    { value: "FJ", label: "Fiji" },
    { value: "FI", label: "Finland" },
    { value: "FR", label: "France" },
    { value: "GF", label: "French Guiana" },
    { value: "PF", label: "French Polynesia" },
    { value: "TF", label: "French Southern Territories" },
    { value: "GA", label: "Gabon" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "Georgia" },
    { value: "DE", label: "Germany" },
    { value: "GH", label: "Ghana" },
    { value: "GI", label: "Gibraltar" },
    { value: "GR", label: "Greece" },
    { value: "GL", label: "Greenland" },
    { value: "GD", label: "Grenada" },
    { value: "GP", label: "Guadeloupe" },
    { value: "GU", label: "Guam" },
    { value: "GT", label: "Guatemala" },
    { value: "GG", label: "Guernsey" },
    { value: "GN", label: "Guinea" },
    { value: "GW", label: "Guinea-Bissau" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haiti" },
    { value: "HM", label: "Heard and McDonald Islands" },
    { value: "VA", label: "Holy See" },
    { value: "HN", label: "Honduras" },
    { value: "HK", label: "Hong Kong SARC" },
    { value: "HU", label: "Hungary" },
    { value: "IS", label: "Iceland" },
    { value: "IN", label: "India" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "Iran (Islamic Republic of)" },
    { value: "IQ", label: "Iraq" },
    { value: "IE", label: "Ireland" },
    { value: "IM", label: "Isle of Man" },
    { value: "IL", label: "Israel" },
    { value: "IT", label: "Italy" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "Japan" },
    { value: "JE", label: "Jersey" },
    { value: "JO", label: "Jordan" },
    { value: "KZ", label: "Kazakhstan" },
    { value: "KE", label: "Kenya" },
    { value: "KI", label: "Kiribati" },
    { value: "KW", label: "Kuwait" },
    { value: "KG", label: "Kyrgyzstan" },
    { value: "LA", label: "Lao People's Democratic Republic" },
    { value: "LV", label: "Latvia" },
    { value: "LB", label: "Lebanon" },
    { value: "LS", label: "Lesotho" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "Libya" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lithuania" },
    { value: "LU", label: "Luxembourg" },
    { value: "MO", label: "Macao SARC" },
    { value: "MK", label: "Macedonia" },
    { value: "MG", label: "Madagascar" },
    { value: "MW", label: "Malawi" },
    { value: "MY", label: "Malaysia" },
    { value: "MV", label: "Maldives" },
    { value: "ML", label: "Mali" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MQ", label: "Martinique" },
    { value: "MR", label: "Mauritania" },
    { value: "MU", label: "Mauritius" },
    { value: "YT", label: "Mayotte" },
    { value: "MX", label: "Mexico" },
    { value: "FM", label: "Micronesia (Federated States of)" },
    { value: "MD", label: "Moldova" },
    { value: "MC", label: "Monaco" },
    { value: "MN", label: "Mongolia" },
    { value: "ME", label: "Montenegro" },
    { value: "MS", label: "Montserrat" },
    { value: "MA", label: "Morocco" },
    { value: "MZ", label: "Mozambique" },
    { value: "MM", label: "Myanmar" },
    { value: "NA", label: "Namibia" },
    { value: "NR", label: "Nauru" },
    { value: "NP", label: "Nepal" },
    { value: "NL", label: "Netherlands" },
    { value: "AN", label: "Netherlands Antilles" },
    { value: "NC", label: "New Caledonia" },
    { value: "NZ", label: "New Zealand" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Niger" },
    { value: "NU", label: "Niue" },
    { value: "NF", label: "Norfolk Island" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "NO", label: "Norway" },
    { value: "OM", label: "Oman" },
    { value: "PK", label: "Pakistan" },
    { value: "PW", label: "Palau" },
    { value: "PS", label: "Palestinian Territory" },
    { value: "PA", label: "Panama" },
    { value: "PG", label: "Papua New Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Peru" },
    { value: "PH", label: "Philippines" },
    { value: "PN", label: "Pitcairn" },
    { value: "PL", label: "Poland" },
    { value: "PT", label: "Portugal" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QA", label: "Qatar" },
    { value: "KR", label: "Republic of Korea" },
    { value: "RE", label: "Réunion" },
    { value: "RO", label: "Romania" },
    { value: "RU", label: "Russia" },
    { value: "RW", label: "Rwanda" },
    { value: "BL", label: "Saint Barthélemy" },
    { value: "SH", label: "Saint Helena" },
    { value: "KN", label: "Saint Kitts and Nevis" },
    { value: "LC", label: "Saint Lucia" },
    { value: "MF", label: "Saint Martin" },
    { value: "PM", label: "Saint Pierre and Miquelon" },
    { value: "VC", label: "Saint Vincent and the Grenadines" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "Sao Tome and Principe" },
    { value: "SA", label: "Saudi Arabia" },
    { value: "SN", label: "Senegal" },
    { value: "RS", label: "Serbia" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leone" },
    { value: "SG", label: "Singapore" },
    { value: "SX", label: "Sint Maarten" },
    { value: "SK", label: "Slovakia" },
    { value: "SI", label: "Slovenia" },
    { value: "SB", label: "Solomon Islands" },
    { value: "SO", label: "Somalia" },
    { value: "ZA", label: "South Africa" },
    { value: "GS", label: "South Georgia and the South Sandwich Islands" },
    { value: "SS", label: "South Sudan" },
    { value: "ES", label: "Spain" },
    { value: "LK", label: "Sri Lanka" },
    { value: "SD", label: "Sudan" },
    { value: "SR", label: "Suriname" },
    { value: "SJ", label: "Svalbard and Jan Mayen" },
    { value: "SZ", label: "Swaziland" },
    { value: "SE", label: "Sweden" },
    { value: "CH", label: "Switzerland" },
    { value: "SY", label: "Syrian Arab Republic (Syria)" },
    { value: "TW", label: "Taiwan, Republic of China" },
    { value: "TJ", label: "Tajikistan" },
    { value: "TZ", label: "Tanzania" },
    { value: "TH", label: "Thailand" },
    { value: "TL", label: "Timor-Leste" },
    { value: "TG", label: "Togo" },
    { value: "TK", label: "Tokelau" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad and Tobago" },
    { value: "TN", label: "Tunisia" },
    { value: "TR", label: "Turkey" },
    { value: "TM", label: "Turkmenistan" },
    { value: "TC", label: "Turks and Caicos Islands" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Ukraine" },
    { value: "AE", label: "United Arab Emirates" },
    { value: "GB", label: "United Kingdom" },
    { value: "US", label: "United States of America" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Uzbekistan" },
    { value: "VU", label: "Vanuatu" },
    { value: "VE", label: "Venezuela (Bolivarian Republic of)" },
    { value: "VN", label: "Vietnam" },
    { value: "WF", label: "Wallis and Futuna" },
    { value: "EH", label: "Western Sahara" },
    { value: "YE", label: "Yemen" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabwe" }
  ];



 export const phoneCode = [
    { countryCode: "NG", value: "234", label: "Nigeria (+234)" },
    { countryCode: "DZ", value: "213", label: "Algeria (+213)" },
    { countryCode: "AD", value: "376", label: "Andorra (+376)" },
    { countryCode: "AO", value: "244", label: "Angola (+244)" },
    { countryCode: "AI", value: "1264", label: "Anguilla (+1264)" },
    { countryCode: "AG", value: "1268", label: "Antigua & Barbuda (+1268)" },
    { countryCode: "AR", value: "54", label: "Argentina (+54)" },
    { countryCode: "AM", value: "374", label: "Armenia (+374)" },
    { countryCode: "AW", value: "297", label: "Aruba (+297)" },
    { countryCode: "AU", value: "61", label: "Australia (+61)" },
    { countryCode: "AT", value: "43", label: "Austria (+43)" },
    { countryCode: "AZ", value: "994", label: "Azerbaijan (+994)" },
    { countryCode: "BS", value: "1242", label: "Bahamas (+1242)" },
    { countryCode: "BH", value: "973", label: "Bahrain (+973)" },
    { countryCode: "BD", value: "880", label: "Bangladesh (+880)" },
    { countryCode: "BB", value: "1246", label: "Barbados (+1246)" },
    { countryCode: "BY", value: "375", label: "Belarus (+375)" },
    { countryCode: "BE", value: "32", label: "Belgium (+32)" },
    { countryCode: "BZ", value: "501", label: "Belize (+501)" },
    { countryCode: "BJ", value: "229", label: "Benin (+229)" },
    { countryCode: "BM", value: "1441", label: "Bermuda (+1441)" },
    { countryCode: "BT", value: "975", label: "Bhutan (+975)" },
    { countryCode: "BO", value: "591", label: "Bolivia (+591)" },
    { countryCode: "BA", value: "387", label: "Bosnia Herzegovina (+387)" },
    { countryCode: "BW", value: "267", label: "Botswana (+267)" },
    { countryCode: "BR", value: "55", label: "Brazil (+55)" },
    { countryCode: "BN", value: "673", label: "Brunei (+673)" },
    { countryCode: "BG", value: "359", label: "Bulgaria (+359)" },
    { countryCode: "BF", value: "226", label: "Burkina Faso (+226)" },
    { countryCode: "BI", value: "257", label: "Burundi (+257)" },
    { countryCode: "KH", value: "855", label: "Cambodia (+855)" },
    { countryCode: "CM", value: "237", label: "Cameroon (+237)" },
    { countryCode: "CA", value: "1", label: "Canada (+1)" },
    { countryCode: "CV", value: "238", label: "Cape Verde Islands (+238)" },
    { countryCode: "KY", value: "1345", label: "Cayman Islands (+1345)" },
    { countryCode: "CF", value: "236", label: "Central African Republic (+236)" },
    { countryCode: "CL", value: "56", label: "Chile (+56)" },
    { countryCode: "CN", value: "86", label: "China (+86)" },
    { countryCode: "CO", value: "57", label: "Colombia (+57)" },
    { countryCode: "KM", value: "269", label: "Comoros (+269)" },
    { countryCode: "CG", value: "242", label: "Congo (+242)" },
    { countryCode: "CK", value: "682", label: "Cook Islands (+682)" },
    { countryCode: "CR", value: "506", label: "Costa Rica (+506)" },
    { countryCode: "HR", value: "385", label: "Croatia (+385)" },
    { countryCode: "CU", value: "53", label: "Cuba (+53)" },
    { countryCode: "CY", value: "90392", label: "Cyprus North (+90392)" },
    { countryCode: "CY", value: "357", label: "Cyprus South (+357)" },
    { countryCode: "CZ", value: "42", label: "Czech Republic (+42)" },
    { countryCode: "DK", value: "45", label: "Denmark (+45)" },
    { countryCode: "DJ", value: "253", label: "Djibouti (+253)" },
    { countryCode: "DM", value: "1809", label: "Dominica (+1809)" },
    { countryCode: "DO", value: "1809", label: "Dominican Republic (+1809)" },
    { countryCode: "EC", value: "593", label: "Ecuador (+593)" },
    { countryCode: "EG", value: "20", label: "Egypt (+20)" },
    { countryCode: "SV", value: "503", label: "El Salvador (+503)" },
    { countryCode: "GQ", value: "240", label: "Equatorial Guinea (+240)" },
    { countryCode: "ER", value: "291", label: "Eritrea (+291)" },
    { countryCode: "EE", value: "372", label: "Estonia (+372)" },
    { countryCode: "ET", value: "251", label: "Ethiopia (+251)" },
    { countryCode: "FK", value: "500", label: "Falkland Islands (+500)" },
    { countryCode: "FO", value: "298", label: "Faroe Islands (+298)" },
    { countryCode: "FJ", value: "679", label: "Fiji (+679)" },
    { countryCode: "FI", value: "358", label: "Finland (+358)" },
    { countryCode: "FR", value: "33", label: "France (+33)" },
    { countryCode: "GF", value: "594", label: "French Guiana (+594)" },
    { countryCode: "PF", value: "689", label: "French Polynesia (+689)" },
    { countryCode: "GA", value: "241", label: "Gabon (+241)" },
    { countryCode: "GM", value: "220", label: "Gambia (+220)" },
    { countryCode: "GE", value: "7880", label: "Georgia (+7880)" },
    { countryCode: "DE", value: "49", label: "Germany (+49)" },
    { countryCode: "GH", value: "233", label: "Ghana (+233)" },
    { countryCode: "GI", value: "350", label: "Gibraltar (+350)" },
    { countryCode: "GR", value: "30", label: "Greece (+30)" },
    { countryCode: "GL", value: "299", label: "Greenland (+299)" },
    { countryCode: "GD", value: "1473", label: "Grenada (+1473)" },
    { countryCode: "GP", value: "590", label: "Guadeloupe (+590)" },
    { countryCode: "GU", value: "671", label: "Guam (+671)" },
    { countryCode: "GT", value: "502", label: "Guatemala (+502)" },
    { countryCode: "GN", value: "224", label: "Guinea (+224)" },
    { countryCode: "GW", value: "245", label: "Guinea - Bissau (+245)" },
    { countryCode: "GY", value: "592", label: "Guyana (+592)" },
    { countryCode: "HT", value: "509", label: "Haiti (+509)" },
    { countryCode: "HN", value: "504", label: "Honduras (+504)" },
    { countryCode: "HK", value: "852", label: "Hong Kong (+852)" },
    { countryCode: "HU", value: "36", label: "Hungary (+36)" },
    { countryCode: "IS", value: "354", label: "Iceland (+354)" },
    { countryCode: "IN", value: "91", label: "India (+91)" },
    { countryCode: "ID", value: "62", label: "Indonesia (+62)" },
    { countryCode: "IR", value: "98", label: "Iran (+98)" },
    { countryCode: "IQ", value: "964", label: "Iraq (+964)" },
    { countryCode: "IE", value: "353", label: "Ireland (+353)" },
    { countryCode: "IL", value: "972", label: "Israel (+972)" },
    { countryCode: "IT", value: "39", label: "Italy (+39)" },
    { countryCode: "JM", value: "1876", label: "Jamaica (+1876)" },
    { countryCode: "JP", value: "81", label: "Japan (+81)" },
    { countryCode: "JO", value: "962", label: "Jordan (+962)" },
    { countryCode: "KZ", value: "7", label: "Kazakhstan (+7)" },
    { countryCode: "KE", value: "254", label: "Kenya (+254)" },
    { countryCode: "KI", value: "686", label: "Kiribati (+686)" },
    { countryCode: "KP", value: "850", label: "Korea North (+850)" },
    { countryCode: "KR", value: "82", label: "Korea South (+82)" },
    { countryCode: "KW", value: "965", label: "Kuwait (+965)" },
    { countryCode: "KG", value: "996", label: "Kyrgyzstan (+996)" },
    { countryCode: "LA", value: "856", label: "Laos (+856)" },
    { countryCode: "LV", value: "371", label: "Latvia (+371)" },
    { countryCode: "LB", value: "961", label: "Lebanon (+961)" },
    { countryCode: "LS", value: "266", label: "Lesotho (+266)" },
    { countryCode: "LR", value: "231", label: "Liberia (+231)" },
    { countryCode: "LY", value: "218", label: "Libya (+218)" },
    { countryCode: "LI", value: "423", label: "Liechtenstein (+423)" },
    { countryCode: "LT", value: "370", label: "Lithuania (+370)" },
    { countryCode: "LU", value: "352", label: "Luxembourg (+352)" },
    { countryCode: "MO", value: "853", label: "Macau (+853)" },
    { countryCode: "MK", value: "389", label: "Macedonia (+389)" },
    { countryCode: "MG", value: "261", label: "Madagascar (+261)" },
    { countryCode: "MW", value: "265", label: "Malawi (+265)" },
    { countryCode: "MY", value: "60", label: "Malaysia (+60)" },
    { countryCode: "MV", value: "960", label: "Maldives (+960)" },
    { countryCode: "ML", value: "223", label: "Mali (+223)" },
    { countryCode: "MT", value: "356", label: "Malta (+356)" },
    { countryCode: "MH", value: "692", label: "Marshall Islands (+692)" },
    { countryCode: "MQ", value: "596", label: "Martinique (+596)" },
    { countryCode: "MR", value: "222", label: "Mauritania (+222)" },
    { countryCode: "MU", value: "230", label: "Mauritius (+230)" },
    { countryCode: "YT", value: "269", label: "Mayotte (+269)" },
    { countryCode: "MX", value: "52", label: "Mexico (+52)" },
    { countryCode: "FM", value: "691", label: "Micronesia (+691)" },
    { countryCode: "MD", value: "373", label: "Moldova (+373)" },
    { countryCode: "MC", value: "377", label: "Monaco (+377)" },
    { countryCode: "MN", value: "976", label: "Mongolia (+976)" },
    { countryCode: "MS", value: "1664", label: "Montserrat (+1664)" },
    { countryCode: "MA", value: "212", label: "Morocco (+212)" },
    { countryCode: "MZ", value: "258", label: "Mozambique (+258)" },
    { countryCode: "MM", value: "95", label: "Myanmar (+95)" },
    { countryCode: "NA", value: "264", label: "Namibia (+264)" },
    { countryCode: "NR", value: "674", label: "Nauru (+674)" },
    { countryCode: "NP", value: "977", label: "Nepal (+977)" },
    { countryCode: "NL", value: "31", label: "Netherlands (+31)" },
    { countryCode: "NC", value: "687", label: "New Caledonia (+687)" },
    { countryCode: "NZ", value: "64", label: "New Zealand (+64)" },
    { countryCode: "NI", value: "505", label: "Nicaragua (+505)" },
    { countryCode: "NE", value: "227", label: "Niger (+227)" },
    { countryCode: "NG", value: "234", label: "Nigeria (+234)" },
    { countryCode: "NU", value: "683", label: "Niue (+683)" },
    { countryCode: "NF", value: "672", label: "Norfolk Islands (+672)" },
    { countryCode: "MP", value: "1670", label: "Northern Mariana Islands (+1670)" },
    { countryCode: "NO", value: "47", label: "Norway (+47)" },
    { countryCode: "OM", value: "968", label: "Oman (+968)" },
    { countryCode: "PK", value: "92", label: "Pakistan (+92)" },
    { countryCode: "PW", value: "680", label: "Palau (+680)" },
    { countryCode: "PA", value: "507", label: "Panama (+507)" },
    { countryCode: "PG", value: "675", label: "Papua New Guinea (+675)" },
    { countryCode: "PY", value: "595", label: "Paraguay (+595)" },
    { countryCode: "PE", value: "51", label: "Peru (+51)" },
    { countryCode: "PH", value: "63", label: "Philippines (+63)" },
    { countryCode: "PL", value: "48", label: "Poland (+48)" },
    { countryCode: "PT", value: "351", label: "Portugal (+351)" },
    { countryCode: "PR", value: "1787", label: "Puerto Rico (+1787)" },
    { countryCode: "QA", value: "974", label: "Qatar (+974)" },
    { countryCode: "RE", value: "262", label: "Reunion (+262)" },
    { countryCode: "RO", value: "40", label: "Romania (+40)" },
    { countryCode: "RU", value: "7", label: "Russia (+7)" },
    { countryCode: "RW", value: "250", label: "Rwanda (+250)" },
    { countryCode: "SH", value: "290", label: "Saint Helena (+290)" },
    { countryCode: "KN", value: "1869", label: "Saint Kitts & Nevis (+1869)" },
    { countryCode: "LC", value: "1758", label: "Saint Lucia (+1758)" },
    { countryCode: "PM", value: "508", label: "Saint Pierre & Miquelon (+508)" },
    { countryCode: "VC", value: "1784", label: "Saint Vincent & Grenadines (+1784)" },
    { countryCode: "WS", value: "685", label: "Samoa (+685)" },
    { countryCode: "SM", value: "378", label: "San Marino (+378)" },
    { countryCode: "ST", value: "239", label: "Sao Tome & Principe (+239)" },
    { countryCode: "SA", value: "966", label: "Saudi Arabia (+966)" },
    { countryCode: "SN", value: "221", label: "Senegal (+221)" },
    { countryCode: "RS", value: "381", label: "Serbia (+381)" },
    { countryCode: "SC", value: "248", label: "Seychelles (+248)" },
    { countryCode: "SL", value: "232", label: "Sierra Leone (+232)" },
    { countryCode: "SG", value: "65", label: "Singapore (+65)" },
    { countryCode: "SX", value: "1721", label: "Sint Maarten (+1721)" },
    { countryCode: "SK", value: "421", label: "Slovak Republic (+421)" },
    { countryCode: "SI", value: "386", label: "Slovenia (+386)" },
    { countryCode: "SB", value: "677", label: "Solomon Islands (+677)" },
    { countryCode: "SO", value: "252", label: "Somalia (+252)" },
    { countryCode: "ZA", value: "27", label: "South Africa (+27)" },
    { countryCode: "GS", value: "500", label: "South Georgia (+500)" },
    { countryCode: "SS", value: "211", label: "South Sudan (+211)" },
    { countryCode: "ES", value: "34", label: "Spain (+34)" },
    { countryCode: "LK", value: "94", label: "Sri Lanka (+94)" },
    { countryCode: "SD", value: "249", label: "Sudan (+249)" },
    { countryCode: "SR", value: "597", label: "Suriname (+597)" },
    { countryCode: "SZ", value: "268", label: "Swaziland (+268)" },
    { countryCode: "SE", value: "46", label: "Sweden (+46)" },
    { countryCode: "CH", value: "41", label: "Switzerland (+41)" },
    { countryCode: "SY", value: "963", label: "Syria (+963)" },
    { countryCode: "TW", value: "886", label: "Taiwan (+886)" },
    { countryCode: "TJ", value: "992", label: "Tajikistan (+992)" },
    { countryCode: "TZ", value: "255", label: "Tanzania (+255)" },
    { countryCode: "TH", value: "66", label: "Thailand (+66)" },
    { countryCode: "TG", value: "228", label: "Togo (+228)" },
    { countryCode: "TK", value: "690", label: "Tokelau (+690)" },
    { countryCode: "TO", value: "676", label: "Tonga (+676)" },
    { countryCode: "TT", value: "1868", label: "Trinidad & Tobago (+1868)" },
    { countryCode: "TN", value: "216", label: "Tunisia (+216)" },
    { countryCode: "TR", value: "90", label: "Turkey (+90)" },
    { countryCode: "TM", value: "993", label: "Turkmenistan (+993)" },
    { countryCode: "TC", value: "1649", label: "Turks & Caicos Islands (+1649)" },
    { countryCode: "TV", value: "688", label: "Tuvalu (+688)" },
    { countryCode: "UG", value: "256", label: "Uganda (+256)" },
    { countryCode: "UA", value: "380", label: "Ukraine (+380)" },
    { countryCode: "AE", value: "971", label: "United Arab Emirates (+971)" },
    { countryCode: "GB", value: "44", label: "United Kingdom (+44)" },
    { countryCode: "US", value: "1", label: "United States (+1)" },
    { countryCode: "UY", value: "598", label: "Uruguay (+598)" },
    { countryCode: "UZ", value: "998", label: "Uzbekistan (+998)" },
    { countryCode: "VU", value: "678", label: "Vanuatu (+678)" },
    { countryCode: "VA", value: "379", label: "Vatican City (+379)" },
    { countryCode: "VE", value: "58", label: "Venezuela (+58)" },
    { countryCode: "VN", value: "84", label: "Vietnam (+84)" },
    { countryCode: "WF", value: "681", label: "Wallis & Futuna (+681)" },
    { countryCode: "EH", value: "212", label: "Western Sahara (+212)" },
    { countryCode: "YE", value: "967", label: "Yemen (+967)" },
    { countryCode: "ZM", value: "260", label: "Zambia (+260)" },
    { countryCode: "ZW", value: "263", label: "Zimbabwe (+263)" },
  ];




 export const currencies = [
    { value: "AFN", label: "Afghan Afghani(AFN)" },
    { value: "ALL", label: "Albanian Lek(ALL)" },
    { value: "DZD", label: "Algerian Dinar(DZD)" },
    { value: "AOA", label: "Angolan Kwanza(AOA)" },
    { value: "ARS", label: "Argentine Peso(ARS)" },
    { value: "AMD", label: "Armenian Dram(AMD)" },
    { value: "AWG", label: "Aruban Florin(AWG)" },
    { value: "AUD", label: "Australian Dollar(AUD)" },
    { value: "AZN", label: "Azerbaijani Manat(AZN)" },
    { value: "BSD", label: "Bahamian Dollar(BSD)" },
    { value: "BHD", label: "Bahraini Dinar(BHD)" },
    { value: "BDT", label: "Bangladeshi Taka(BDT)" },
    { value: "BBD", label: "Barbadian Dollar(BBD)" },
    { value: "BYR", label: "Belarusian Ruble(BYR)" },
    { value: "BEF", label: "Belgian Franc(BEF)" },
    { value: "BZD", label: "Belize Dollar(BZD)" },
    { value: "BMD", label: "Bermudan Dollar(BMD)" },
    { value: "BTN", label: "Bhutanese Ngultrum(BTN)" },
    { value: "BTC", label: "Bitcoin(BTC)" },
    { value: "BOB", label: "Bolivian Boliviano(BOB)" },
    { value: "BAM", label: "Bosnia-Herzegovina Convertible Mark(BAM)" },
    { value: "BWP", label: "Botswanan Pula(BWP)" },
    { value: "BRL", label: "Brazilian Real(BRL)" },
    { value: "GBP", label: "British Pound Sterling(GBP)" },
    { value: "BND", label: "Brunei Dollar(BND)" },
    { value: "BGN", label: "Bulgarian Lev(BGN)" },
    { value: "BIF", label: "Burundian Franc(BIF)" },
    { value: "KHR", label: "Cambodian Riel(KHR)" },
    { value: "CAD", label: "Canadian Dollar(CAD)" },
    { value: "CVE", label: "Cape Verdean Escudo(CVE)" },
    { value: "KYD", label: "Cayman Islands Dollar(KYD)" },
    { value: "XOF", label: "CFA Franc BCEAO(XOF)" },
    { value: "XAF", label: "CFA Franc BEAC(XAF)" },
    { value: "XPF", label: "CFP Franc(XPF)" },
    { value: "CLP", label: "Chilean Peso(CLP)" },
    { value: "CNY", label: "Chinese Yuan(CNY)" },
    { value: "COP", label: "Colombian Peso(COP)" },
    { value: "KMF", label: "Comorian Franc(KMF)" },
    { value: "CDF", label: "Congolese Franc(CDF)" },
    { value: "CRC", label: "Costa Rican Colón(CRC)" },
    { value: "HRK", label: "Croatian Kuna(HRK)" },
    { value: "CUC", label: "Cuban Convertible Peso(CUC)" },
    { value: "CZK", label: "Czech Republic Koruna(CZK)" },
    { value: "DKK", label: "Danish Krone(DKK)" },
    { value: "DJF", label: "Djiboutian Franc(DJF)" },
    { value: "DOP", label: "Dominican Peso(DOP)" },
    { value: "XCD", label: "East Caribbean Dollar(XCD)" },
    { value: "EGP", label: "Egyptian Pound(EGP)" },
    { value: "ERN", label: "Eritrean Nakfa(ERN)" },
    { value: "EEK", label: "Estonian Kroon(EEK)" },
    { value: "ETB", label: "Ethiopian Birr(ETB)" },
    { value: "EUR", label: "Euro(EUR)" },
    { value: "FKP", label: "Falkland Islands Pound(FKP)" },
    { value: "FJD", label: "Fijian Dollar(FJD)" },
    { value: "GMD", label: "Gambian Dalasi(GMD)" },
    { value: "GEL", label: "Georgian Lari(GEL)" },
    { value: "DEM", label: "German Mark(DEM)" },
    { value: "GHS", label: "Ghanaian Cedi(GHS)" },
    { value: "GIP", label: "Gibraltar Pound(GIP)" },
    { value: "GRD", label: "Greek Drachma(GRD)" },
    { value: "GTQ", label: "Guatemalan Quetzal(GTQ)" },
    { value: "GNF", label: "Guinean Franc(GNF)" },
    { value: "GYD", label: "Guyanaese Dollar(GYD)" },
    { value: "HTG", label: "Haitian Gourde(HTG)" },
    { value: "HNL", label: "Honduran Lempira(HNL)" },
    { value: "HKD", label: "Hong Kong Dollar(HKD)" },
    { value: "HUF", label: "Hungarian Forint(HUF)" },
    { value: "ISK", label: "Icelandic Króna(ISK)" },
    { value: "INR", label: "Indian Rupee(INR)" },
    { value: "IDR", label: "Indonesian Rupiah(IDR)" },
    { value: "IRR", label: "Iranian Rial(IRR)" },
    { value: "IQD", label: "Iraqi Dinar(IQD)" },
    { value: "ILS", label: "Israeli New Sheqel(ILS)" },
    { value: "ITL", label: "Italian Lira(ITL)" },
    { value: "JMD", label: "Jamaican Dollar(JMD)" },
    { value: "JPY", label: "Japanese Yen(JPY)" },
    { value: "JOD", label: "Jordanian Dinar(JOD)" },
    { value: "KZT", label: "Kazakhstani Tenge(KZT)" },
    { value: "KES", label: "Kenyan Shilling(KES)" },
    { value: "KWD", label: "Kuwaiti Dinar(KWD)" },
    { value: "KGS", label: "Kyrgystani Som(KGS)" },
    { value: "LAK", label: "Laotian Kip(LAK)" },
    { value: "LVL", label: "Latvian Lats(LVL)" },
    { value: "LBP", label: "Lebanese Pound(LBP)" },
    { value: "LSL", label: "Lesotho Loti(LSL)" },
    { value: "LRD", label: "Liberian Dollar(LRD)" },
    { value: "LYD", label: "Libyan Dinar(LYD)" },
    { value: "LTL", label: "Lithuanian Litas(LTL)" },
    { value: "MOP", label: "Macanese Pataca(MOP)" },
    { value: "MKD", label: "Macedonian Denar(MKD)" },
    { value: "MGA", label: "Malagasy Ariary(MGA)" },
    { value: "MWK", label: "Malawian Kwacha(MWK)" },
    { value: "MYR", label: "Malaysian Ringgit(MYR)" },
    { value: "MVR", label: "Maldivian Rufiyaa(MVR)" },
    { value: "MRO", label: "Mauritanian Ouguiya(MRO)" },
    { value: "MUR", label: "Mauritian Rupee(MUR)" },
    { value: "MXN", label: "Mexican Peso(MXN)" },
    { value: "MDL", label: "Moldovan Leu(MDL)" },
    { value: "MNT", label: "Mongolian Tugrik(MNT)" },
    { value: "MAD", label: "Moroccan Dirham(MAD)" },
    { value: "MZM", label: "Mozambican Metical(MZM)" },
    { value: "MMK", label: "Myanmar Kyat(MMK)" },
    { value: "NAD", label: "Namibian Dollar(NAD)" },
    { value: "NPR", label: "Nepalese Rupee(NPR)" },
    { value: "ANG", label: "Netherlands Antillean Guilder(ANG)" },
    { value: "TWD", label: "New Taiwan Dollar(TWD)" },
    { value: "NZD", label: "New Zealand Dollar(NZD)" },
    { value: "NIO", label: "Nicaraguan Córdoba(NIO)" },
    { value: "NGN", label: "Nigerian Naira(NGN)" },
    { value: "KPW", label: "North Korean Won(KPW)" },
    { value: "NOK", label: "Norwegian Krone(NOK)" },
    { value: "OMR", label: "Omani Rial(OMR)" },
    { value: "PKR", label: "Pakistani Rupee(PKR)" },
    { value: "PAB", label: "Panamanian Balboa(PAB)" },
    { value: "PGK", label: "Papua New Guinean Kina(PGK)" },
    { value: "PYG", label: "Paraguayan Guarani(PYG)" },
    { value: "PEN", label: "Peruvian Nuevo Sol(PEN)" },
    { value: "PHP", label: "Philippine Peso(PHP)" },
    { value: "PLN", label: "Polish Zloty(PLN)" },
    { value: "QAR", label: "Qatari Rial(QAR)" },
    { value: "RON", label: "Romanian Leu(RON)" },
    { value: "RUB", label: "Russian Ruble(RUB)" },
    { value: "RWF", label: "Rwandan Franc(RWF)" },
    { value: "SVC", label: "Salvadoran Colón(SVC)" },
    { value: "WST", label: "Samoan Tala(WST)" },
    { value: "SAR", label: "Saudi Riyal(SAR)" },
    { value: "RSD", label: "Serbian Dinar(RSD)" },
    { value: "SCR", label: "Seychellois Rupee(SCR)" },
    { value: "SLL", label: "Sierra Leonean Leone(SLL)" },
    { value: "SGD", label: "Singapore Dollar(SGD)" },
    { value: "SKK", label: "Slovak Koruna(SKK)" },
    { value: "SBD", label: "Solomon Islands Dollar(SBD)" },
    { value: "SOS", label: "Somali Shilling(SOS)" },
    { value: "ZAR", label: "South African Rand(ZAR)" },
    { value: "KRW", label: "South Korean Won(KRW)" },
    { value: "XDR", label: "Special Drawing Rights(XDR)" },
    { value: "LKR", label: "Sri Lankan Rupee(LKR)" },
    { value: "SHP", label: "St. Helena Pound(SHP)" },
    { value: "SDG", label: "Sudanese Pound(SDG)" },
    { value: "SRD", label: "Surinamese Dollar(SRD)" },
    { value: "SZL", label: "Swazi Lilangeni(SZL)" },
    { value: "SEK", label: "Swedish Krona(SEK)" },
    { value: "CHF", label: "Swiss Franc(CHF)" },
    { value: "SYP", label: "Syrian Pound(SYP)" },
    { value: "STD", label: "São Tomé and Príncipe Dobra(STD)" },
    { value: "TJS", label: "Tajikistani Somoni(TJS)" },
    { value: "TZS", label: "Tanzanian Shilling(TZS)" },
    { value: "THB", label: "Thai Baht(THB)" },
    { value: "TOP", label: "Tongan Paʻanga(TOP)" },
    { value: "TTD", label: "Trinidad & Tobago Dollar(TTD)" },
    { value: "TND", label: "Tunisian Dinar(TND)" },
    { value: "TRY", label: "Turkish Lira(TRY)" },
    { value: "TMT", label: "Turkmenistani Manat(TMT)" },
    { value: "UGX", label: "Ugandan Shilling(UGX)" },
    { value: "UAH", label: "Ukrainian Hryvnia(UAH)" },
    { value: "AED", label: "United Arab Emirates Dirham(AED)" },
    { value: "UYU", label: "Uruguayan Peso(UYU)" },
    { value: "USD", label: "US Dollar(USD)" },
    { value: "UZS", label: "Uzbekistan Som(UZS)" },
    { value: "VUV", label: "Vanuatu Vatu(VUV)" },
    { value: "VEF", label: "Venezuelan Bolívar(VEF)" },
    { value: "VND", label: "Vietnamese Dong(VND)" },
    { value: "YER", label: "Yemeni Rial(YER)" },
    { value: "ZMK", label: "Zambian Kwacha(ZMK)" },
  ];
  